import { angularJsApp } from "../app";
import { AppServicesEnum } from "../app.model";
import { IApiCentresServeiMunicipis } from "./api.model";
import { NotificationsService } from "./notification.service";
import { SharedProperties } from "./share.service";

export class ServeisEducatius {
  private apiUrl = `${this.SharedProperties.baseUrlService()}/MOE/services`;

  constructor(
    private NotificationsService: NotificationsService,
    private SharedProperties: SharedProperties,
    private $http: ng.IHttpService,
    private $rootScope: ng.IScope,    
  ) { }

  getCentres(paramsMapes: any): angular.IPromise<any> { 
    const _params = { ...paramsMapes };
    return this.$http
      .post(`${this.apiUrl}/serveisEducatius/find`, _params)
      .then((response: any) => ({
        centres: response.data.serveisEducatius,
        registresTotal: response.data.registresTotal
      }))
      .catch(() => {
        this.NotificationsService.sendMessage("S'ha produit un error al carregar els centres", "error");
        this.$rootScope.$broadcast("error");
      });
  }

  getCentreDetail(codiServei: string, tipusInfo: string): angular.IPromise<IApiCentresServeiMunicipis[]> { 
    const _params = { params: { codiServei, tipusInfo } };
    return this.$http
      .get(`${this.apiUrl}/serveisEducatiusDetall/find`, _params)
      .then((response: any) => (response.data.serveisEducatiusDetall))
      .catch(() => {
        this.NotificationsService.sendMessage("S'ha produit un error al carregar els centres", "error");
        this.$rootScope.$broadcast("error");
      });
  }

  getNomCentresAhead(paramsMapes: any): angular.IPromise<any[]> {
    const _params = { ...paramsMapes };
    return this.$http
      .post(`${this.apiUrl}/serveisEducatius/findTypeahead?`, _params)
      .then((response: any) => response.data.centres)
      .catch((error) => console.error(error));
  }

  exportarCentres(paramsExcel: any): angular.IPromise<void> {
    return this.exportExcel(`${this.apiUrl}/serveisEducatius/exportServeis`, paramsExcel);
  }

  private exportExcel(url: string, paramsExcel: any): angular.IPromise<void> {
    return this.$http
      .post(url, paramsExcel, { responseType: "arraybuffer" })
      .then((response: any) => {
        const isIE = !!(document as any).documentMode;
        const blob = new Blob([response.data], { type: "application/vnd.ms-excel" });
        if (isIE && (window.navigator as any).msSaveOrOpenBlob) {
          (window.navigator as any).msSaveOrOpenBlob(blob, "Exportacio_IE.xls");
        } else {
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = "Exportacio.xls";
          document.body?.appendChild(link);
          link.click();
        }
      });
  }
}

angularJsApp.service(AppServicesEnum.SERVEIS_EDUCATIUS_SERVICE, ServeisEducatius);
